/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCollapseRow = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 16v6H2v-6zm-2 2H4v2h16zm2-16v2h-9v5.586l3.293-3.293 1.414 1.414L12 13.414 6.293 7.707l1.414-1.414L11 9.586V4H2V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCollapseRow as CollapseRow };
